import axios from 'axios'

const api = axios.create({
  baseURL: '/'
})

export const setBaseURL = (url) => {
  api.defaults.baseURL = url
  api.defaults.withCredentials = true
}

export const getBaseURL = () => {
  return api.defaults.baseURL
}

export default api
